module.exports = "/_next/static/images/fieldTechnicians-402ed4a5556c252f701ba4d03032f368.webp";